"use strict";

var _typeof = require("@babel/runtime-corejs3/helpers/typeof");
var _Object$keys = require("@babel/runtime-corejs3/core-js-stable/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols");
var _filterInstanceProperty = require("@babel/runtime-corejs3/core-js-stable/instance/filter");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors");
var _WeakMap = require("@babel/runtime-corejs3/core-js-stable/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Popper = exports.POPPER_WIDTH_SIZING = exports.POPPER_PLACEMENTS = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/objectWithoutProperties"));
var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/toConsumableArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));
var _bind = _interopRequireDefault(require("classnames/bind"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactMergeRefs = _interopRequireDefault(require("react-merge-refs"));
var _useWaitForDOMRef = _interopRequireDefault(require("react-overlays/useWaitForDOMRef"));
var _react = require("@floating-ui/react");
var _react2 = _interopRequireWildcard(require("react"));
var _keycode = _interopRequireDefault(require("../keycode/keycode"));
var _useModalManager = require("./useModalManager");
var _nanoid = require("./nanoid");
var _PopperContainer = require("./_PopperContainer");
var _CustomPropTypes = _interopRequireDefault(require("./CustomPropTypes"));
var _AddChildPropsContext = require("./_AddChildPropsContext");
var _Popper = _interopRequireDefault(!!(typeof window !== 'undefined' && window.document && window.document.createElement) ? require("./Popper.css") : void 0);
var _excluded = ["className", "innerRef", "style", "role"];
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? Object.defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; } /* eslint-disable no-param-reassign */
var CSS_BLOCK = 'sapcnqr-popper';
var ARROW_HEIGHT = 8;
var ARROW_WIDTH = 16;

// capture ensures this is called before an underlying modal event listener
var eventListenerOptions = {
  capture: true
};
var POPPER_PLACEMENTS = exports.POPPER_PLACEMENTS = ['auto-start', 'auto', 'auto-end', 'bottom-start', 'bottom', 'bottom-end', 'left-start', 'left', 'left-end', 'right-start', 'right', 'right-end', 'top-start', 'top', 'top-end'];
var POPPER_WIDTH_SIZING = exports.POPPER_WIDTH_SIZING = ['none', 'matchTarget', 'minTarget', 'maxTarget'];
var Popper = exports.Popper = function Popper(_props) {
  var addChildProps = (0, _AddChildPropsContext.useAddChildProps)();
  var props = addChildProps ? _objectSpread(_objectSpread({}, _props), addChildProps(Popper, _props)) : _props;
  var modalManager = (0, _useModalManager.useModalManager)();
  var container = (0, _useWaitForDOMRef.default)();
  var arrowClassName = props.arrowClassName,
    children = props.children,
    customContainer = props.customContainer,
    disableEdgeDetection = props.disableEdgeDetection,
    disableHideWhenTargetIsHidden = props.disableHideWhenTargetIsHidden,
    disablePopperContainer = props.disablePopperContainer,
    flipContainer = props.flipContainer,
    maxWidth = props.maxWidth,
    offset = props.offset,
    onEscapeKey = props.onEscapeKey,
    onKeyDown = props.onKeyDown,
    popperClassName = props.popperClassName,
    _props$popperContentP = props.popperContentProps,
    popperContentProps = _props$popperContentP === void 0 ? {} : _props$popperContentP,
    _props$popperMiddlewa = props.popperMiddleware,
    popperMiddleware = _props$popperMiddlewa === void 0 ? [] : _props$popperMiddlewa,
    _props$popperPlacemen = props.popperPlacement,
    popperPlacement = _props$popperPlacemen === void 0 ? ['bottom-start', 'top-start', 'bottom-end', 'top-end'] : _props$popperPlacemen,
    _props$popperProps = props.popperProps,
    popperProps = _props$popperProps === void 0 ? {} : _props$popperProps,
    renderTargetComponent = props.renderTargetComponent,
    show = props.show,
    showArrow = props.showArrow,
    skidding = props.skidding,
    targetClassName = props.targetClassName,
    targetComponent = props.targetComponent,
    targetProps = props.targetProps,
    _props$widthSizingTyp = props.widthSizingType,
    widthSizingType = _props$widthSizingTyp === void 0 ? 'none' : _props$widthSizingTyp,
    widthSizingTargetRef = props.widthSizingTargetRef;
  var classnames = _bind.default.bind(_Popper.default);
  var placementsAsArray = Array.isArray(popperPlacement) ? popperPlacement : [popperPlacement];
  var hasAutoPlacement = (0, _includes.default)(placementsAsArray).call(placementsAsArray, function (placement) {
    return (0, _includes.default)(placement).call(placement, 'auto');
  });
  var middleware = [(0, _react.offset)({
    mainAxis: offset || 0 + (showArrow ? ARROW_HEIGHT + 2 : 0),
    crossAxis: skidding || 0
  })];
  if (!disableEdgeDetection) {
    var fallbackPlacements = (0, _slice.default)(placementsAsArray).call(placementsAsArray, 1);
    middleware.push((0, _react.flip)({
      fallbackPlacements: fallbackPlacements.length ? fallbackPlacements : undefined,
      boundary: flipContainer || undefined
    }));
  }
  if (hasAutoPlacement) {
    middleware.push((0, _react.autoPlacement)());
  }
  middleware.push((0, _react.shift)({
    boundary: flipContainer
  }));
  var arrowRef = (0, _react2.useRef)(null);
  if (showArrow) {
    middleware.push((0, _react.arrow)({
      element: arrowRef,
      // Account for the border-radius
      padding: 6
    }));
  }
  if (!disableHideWhenTargetIsHidden) {
    middleware.push((0, _react.hide)());
  }
  middleware.push.apply(middleware, (0, _toConsumableArray2.default)(popperMiddleware));

  // change the reference target element for the popper
  // to the widthSizingTargetRef if it is provided
  var additionalFloatingOptions = {};
  if (widthSizingTargetRef) {
    additionalFloatingOptions = {
      elements: {
        reference: widthSizingTargetRef === null || widthSizingTargetRef === void 0 ? void 0 : widthSizingTargetRef.current
      }
    };
  }
  var _useFloating = (0, _react.useFloating)(_objectSpread(_objectSpread({}, additionalFloatingOptions), {}, {
      placement: placementsAsArray[0],
      open: show,
      middleware: middleware,
      whileElementsMounted: _react.autoUpdate
    })),
    refs = _useFloating.refs,
    floatingStyles = _useFloating.floatingStyles,
    context = _useFloating.context,
    placement = _useFloating.placement,
    elements = _useFloating.elements;
  var role = (0, _react.useRole)(context, {
    role: (popperProps === null || popperProps === void 0 ? void 0 : popperProps.role) || 'dialog'
  });
  var _useInteractions = (0, _react.useInteractions)([role]),
    getFloatingUiReferenceProps = _useInteractions.getReferenceProps,
    getFloatingProps = _useInteractions.getFloatingProps;
  (0, _react2.useEffect)(function () {
    if (show) {
      var modalId = (0, _nanoid.generate)();
      var handleDocumentKeyDown = function handleDocumentKeyDown(e) {
        if (modalManager.isTopModal(modalId)) {
          onKeyDown === null || onKeyDown === void 0 || onKeyDown(e);
          if (e.keyCode === _keycode.default.codes.esc && onEscapeKey) {
            e.stopPropagation();
            onEscapeKey(e);
          }
        }
      };
      modalManager.add(modalId, container);
      document.addEventListener('keydown', handleDocumentKeyDown, eventListenerOptions);
      return function () {
        document.removeEventListener('keydown', handleDocumentKeyDown, eventListenerOptions);
        modalManager.remove(modalId);
      };
    }
    return function () {};
  }, [show]);
  var popperPropsClassName = popperProps.className,
    innerRef = popperProps.innerRef,
    popperPropsStyle = popperProps.style,
    _role = popperProps.role,
    otherPopperProps = (0, _objectWithoutProperties2.default)(popperProps, _excluded);
  var popperClasses = classnames(CSS_BLOCK, popperClassName, popperPropsClassName);
  var targetClasses = classnames("".concat(CSS_BLOCK, "__target"), targetClassName, targetProps === null || targetProps === void 0 ? void 0 : targetProps.className);
  var contentClasses = classnames("".concat(CSS_BLOCK, "__content"), popperContentProps.className);
  if (!disableHideWhenTargetIsHidden && elements.reference && elements.floating) {
    (0, _react.computePosition)(elements.reference, elements.floating, {
      middleware: [(0, _react.hide)()]
    }).then(function (_ref) {
      var middlewareData = _ref.middlewareData;
      var referenceHidden = middlewareData.hide.referenceHidden;
      if (referenceHidden) {
        elements.floating.classList.add("".concat(CSS_BLOCK, "--reference-hidden"));
      } else {
        elements.floating.classList.remove("".concat(CSS_BLOCK, "--reference-hidden"));
      }
    });
  }
  var styleOverrides = {};
  if (elements.reference) {
    if (typeof maxWidth === 'number') {
      styleOverrides.maxWidth = "".concat(maxWidth, "px");
    }
    if (widthSizingType === 'minTarget') {
      styleOverrides.minWidth = "".concat(elements.reference.getBoundingClientRect().width, "px");
    }
    if (widthSizingType === 'matchTarget') {
      styleOverrides.width = "".concat(elements.reference.getBoundingClientRect().width, "px");
    }
    if (widthSizingType === 'maxTarget') {
      styleOverrides.maxWidth = "".concat(elements.reference.getBoundingClientRect().width, "px");
    }
  }
  var popper = /*#__PURE__*/_react2.default.createElement("div", (0, _extends2.default)({}, otherPopperProps, {
    ref: otherPopperProps !== null && otherPopperProps !== void 0 && otherPopperProps.ref ? (0, _reactMergeRefs.default)([otherPopperProps.ref, refs.setFloating]) : refs.setFloating,
    className: popperClasses,
    "data-placement": placement,
    style: _objectSpread(_objectSpread(_objectSpread({}, popperPropsStyle), floatingStyles), styleOverrides)
  }, getFloatingProps(), {
    id: otherPopperProps.id || getFloatingProps().id
  }), /*#__PURE__*/_react2.default.createElement("div", (0, _extends2.default)({}, popperContentProps, {
    className: contentClasses,
    ref: innerRef
  }), children), showArrow && /*#__PURE__*/_react2.default.createElement(_react.FloatingArrow, {
    className: classnames("".concat(CSS_BLOCK, "__arrow"), arrowClassName),
    ref: arrowRef,
    context: context,
    height: ARROW_HEIGHT,
    width: ARROW_WIDTH
  }));
  if (!disablePopperContainer) {
    popper = /*#__PURE__*/_react2.default.createElement(_PopperContainer.PopperContainer, {
      customContainer: customContainer
    }, popper);
  }
  var mergedRef = targetProps !== null && targetProps !== void 0 && targetProps.ref ? (0, _reactMergeRefs.default)([targetProps.ref, refs.setReference]) : refs.setReference;
  var getReferenceProps = function getReferenceProps() {
    var floatingUiReferenceProps = getFloatingUiReferenceProps();
    var floatingUiAriaControls = floatingUiReferenceProps['aria-controls'];
    if (floatingUiAriaControls) {
      return _objectSpread(_objectSpread({}, floatingUiReferenceProps), {}, {
        'aria-controls': otherPopperProps.id || floatingUiAriaControls
      });
    }
    return floatingUiReferenceProps;
  };
  return /*#__PURE__*/_react2.default.createElement(_react2.default.Fragment, null, typeof renderTargetComponent === 'function' ? renderTargetComponent(mergedRef, getReferenceProps(), targetClasses, targetProps) : /*#__PURE__*/_react2.default.createElement("div", (0, _extends2.default)({}, targetProps, {
    className: targetClasses,
    ref: mergedRef,
    "data-popper-wrapper": true
  }), targetComponent), show && popper);
};
Popper.displayName = 'Popper';
Popper.propTypes = {
  children: _propTypes.default.node.isRequired,
  customContainer: _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]),
  arrowClassName: _propTypes.default.string,
  disableEdgeDetection: _propTypes.default.bool,
  disableHideWhenTargetIsHidden: _propTypes.default.bool,
  disablePopperContainer: _propTypes.default.bool,
  flipContainer: _CustomPropTypes.default.elementOrArrayOfElements(),
  maxWidth: _propTypes.default.number,
  offset: _propTypes.default.number,
  popperClassName: _propTypes.default.string,
  popperContentProps: _propTypes.default.object,
  popperMiddleware: _propTypes.default.array,
  popperPlacement: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.oneOf(POPPER_PLACEMENTS)), _propTypes.default.oneOf(POPPER_PLACEMENTS)]),
  popperProps: _propTypes.default.object,
  renderTargetComponent: _propTypes.default.func,
  show: _propTypes.default.bool,
  showArrow: _propTypes.default.bool,
  skidding: _propTypes.default.number,
  targetComponent: _propTypes.default.element,
  targetClassName: _propTypes.default.string,
  targetProps: _propTypes.default.object,
  widthSizingType: _propTypes.default.oneOf(POPPER_WIDTH_SIZING),
  widthSizingTargetRef: _propTypes.default.any,
  onEscapeKey: _propTypes.default.func,
  onKeyDown: _propTypes.default.func
};
var _default = exports.default = Popper;